import React from 'react'
import { Box, Typography } from '@mui/material'
import { stDesk } from './stylesMensagens'
import moment from 'moment'
import { BsCheckAll } from 'react-icons/bs'

export default function Mensagens({ index, msg, chat }) {
  return (
    <Box key={index} sx={msg.criadaPorAdmin ? stDesk.containMsgGestor : stDesk.containMsgUser}>
      <Box sx={msg.criadaPorAdmin ? stDesk.containGestor : stDesk.containUsuario}>
        <Typography
          variant='h6'
          sx={
            msg.criadaPorAdmin
              ? { ...stDesk.titleGestor, color: '#b02c04' }
              : { ...stDesk.titleGestor, color: '#FF7043' }
          }
        >
          {msg.criadaPorAdmin ? chat.pedido.empresa.nome : 'Eu'}
        </Typography>
        <Typography
          variant='h6'
          sx={msg.criadaPorAdmin ? stDesk.textoMsg : { ...stDesk.textoMsg, color: 'black' }}
        >
          {msg.texto}
        </Typography>
        {msg.criadaPorAdmin ? (
          <Box sx={stDesk.containDataCheck}>
            <Typography sx={{ ...stDesk.labelData, color: 'white' }} variant='h6'>
              {`Recebido ${moment(msg.createdAt).format('ddd, DD/MM/YY')} às ${moment(msg.createdAt).format('hh:mm')}`}
            </Typography>
          </Box>
        ) : (
          <Box sx={stDesk.containDataCheck}>
            <Typography sx={stDesk.labelData} variant='h6'>
              {`Enviado ${moment(msg.createdAt).format('ddd, DD/MM/YY')} às ${moment(msg.createdAt).format('hh:mm')}`}
            </Typography>
            <BsCheckAll size={20} color={msg.status === 'LIDA' ? '#6c6cff' : 'gray'} />
          </Box>
        )}
      </Box>
    </Box>
  )
}
